import {LOGIN_USER, LOGOUT_USER} from "../../constant/reducerConstants";

const initialState = {
    siteId: '',
    taskId: ''
};

export function userReducer(state = initialState, action) {
    switch (action.type) {
        case LOGIN_USER:
            return {
                ...state,
                siteId: action.data.siteId,
                taskId: action.data.taskId
            };
        case LOGOUT_USER:
            return {
                ...state,
                ...initialState
            };
        default:
            return state;
    }
}


// WEBPACK FOOTER //
// ./src/state/reducer/userReducer.js